import * as React from 'react';
import './style.scss';

/**
 * Lightweight placeholder shown while a lazily-loaded route chunk downloads.
 * Deliberately dependency-free so it stays in the main bundle.
 */
export default function RouteFallback() {
  return (
    <div className="route-fallback" role="status" aria-live="polite" aria-busy="true">
      <span className="route-fallback__spinner" aria-hidden="true" />
      <span className="v-sr-only">Đang tải nội dung…</span>
    </div>
  );
}
